<div class="relative">
  <app-icon-button (click)="yearOpen.set(true)"
    ><p class="font-semibold text-base md:text-lg">
      {{ value() | date: 'y년' }}
    </p></app-icon-button
  >
  @if (yearOpen()) {
    <app-year-select
      [value]="value()!"
      (clickOutside)="yearOpen.set(false)"
      (select)="handleSelectYear($event)"
      class="absolute z-[99] left-0 top-[calc(100%+4px)]"
    />
  }
</div>
